export const ReportKindMap = {
  graduate_enrollment_academic_record: 'Histórico escolar',
  student_graduate_course_certificate: 'Certificado'
};
